// index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppProvider as PolarisProvider } from '@shopify/polaris';
import "@shopify/polaris/build/esm/styles.css";
import en from "@shopify/polaris/locales/en.json";
import App from "./App.jsx";

/**
 * Read API key from the <meta name="shopify-api-key"> tag (preferred when using CDN),
 * falling back to Vite env for local/dev.
 */
function getApiKey() {
  const meta = document.querySelector('meta[name="shopify-api-key"]');
  const metaKey = meta?.content?.trim();
  return metaKey || import.meta.env.VITE_SHOPIFY_API_KEY || "";
}

/**
 * Parse query for host/shop. Shopify embedded apps MUST have ?host=...
 */
function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    host: params.get("host") || "",
    shop: params.get("shop") || "",
    embedded: params.get("embedded") || "",
  };
}

const apiKey = getApiKey();
const { host, shop } = getQueryParams();

if (!apiKey) {
  // Fail fast with a visible message
  document.body.innerHTML =
    '<div style="padding:16px;font:14px system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">Missing Shopify API key. Add <code>&lt;meta name="shopify-api-key" content="%VITE_SHOPIFY_API_KEY%" /&gt;</code> to <b>index.html</b> (or set <code>VITE_SHOPIFY_API_KEY</code>).</div>';
  throw new Error("Shopify API key missing");
}

if (!host) {
  // Kick off OAuth at top-level. Include ?shop if we have it.
  const url = shop ? `/api/auth?shop=${encodeURIComponent(shop)}` : "/api/auth";
  window.location.replace(url);
  throw new Error("Missing ?host; redirecting to /api/auth");
}

// (Optional) Log whether the CDN script is present (doesn't block rendering)
if (window.appBridge || window["app-bridge"]) {
  // eslint-disable-next-line no-console
  console.log("[AppBridge] CDN script detected.");
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "[AppBridge] CDN script not detected yet. The React provider will still initialize via the npm package."
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PolarisProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PolarisProvider>
  </React.StrictMode>
);
